export interface Identifiable {
  id: number
}

export function isIdentifiable(object: any): object is Identifiable {
  return 'id' in object
}
